import { REACT_APP_DISABLE_TRACKING } from 'env'
import { MemberProfile } from 'types'
import { reportError } from 'utils/error'

export const INVITE_MEMBER_EVENT = 'invite_member'
export const CREATE_DOC_EVENT = 'create_doc'
export const PAYMENT_SUCCEEDED_EVENT = 'payment_succeeded'
export const CREATE_REVIEW_REQUEST_EVENT = 'create_review_request'
export const SUBMIT_INFORMAL_FEEDBACK_REVIEW_EVENT = 'submit_informal_feedback_review'
export const CREATE_HANDBOOK_EVENT = 'create_handbook'
export const ADD_HANDBOOK_ITEM_EVENT = 'add_handbook_item'
export const SIGNED_UP_EVENT = 'signed_up'
export const AUTHED_SESSION_EVENT = 'authed_session'
export const TRIAL_REQUESTED = 'trial_requested'
export const TRIAL_GRANTED = 'trial_granted'
export const BRAND_KIT_CREATED = 'brand_kit_created'
export const CONTENT_GENERATED = 'content_generated'

export const trackEvent = (event: string, profile?: MemberProfile | undefined, props?: object | null) => {
  if (REACT_APP_DISABLE_TRACKING) return null

  const email = profile?.email || ''
  const phone = profile?.phone
  const almanac_user_id = profile?.id
  const otherProps = props || {}

  try {
    window.dataLayer?.push({ event, email, phone, almanac_user_id, ...otherProps })
  } catch (error) {
    reportError(error)
  }
}
